<script lang="ts">
	// The design system's Secret (design/components/surfaces/Secret.jsx): a
	// value shown once, on the emphasis surface, such as a pairing code the
	// owner reads out to the till. The value is left to right and mono in both
	// languages; a long one (size 14 or less) breaks anywhere rather than
	// running off the card.
	//
	// The app adds test ids, for the value and for the action.

	interface Props {
		value: string;
		label?: string;
		/** What to do with the value, under it. */
		note?: string;
		action?: string;
		onAction?: () => void;
		size?: number;
		tracking?: string;
		testId?: string;
		valueTestId?: string;
		actionTestId?: string;
	}

	let {
		value,
		label,
		note,
		action,
		onAction,
		size = 34,
		tracking = '.12em',
		testId,
		valueTestId,
		actionTestId,
	}: Props = $props();
</script>

<div class="secret" data-testid={testId}>
	{#if label}
		<p class="label">{label}</p>
	{/if}
	<p
		class="value"
		class:long={size <= 14}
		dir="ltr"
		style:font-size="{size}px"
		style:letter-spacing={tracking}
		data-testid={valueTestId}
	>
		{value}
	</p>
	{#if note}
		<p class="note">{note}</p>
	{/if}
	{#if action}
		<button type="button" class="action" data-testid={actionTestId} onclick={onAction}>
			{action}
		</button>
	{/if}
</div>

<style>
	.secret {
		background: var(--surface-invert);
		color: var(--on-ink);
		border-radius: var(--radius-panel);
		padding: var(--card-pad);
	}

	.label {
		margin: 0 0 4px;
		font-family: var(--font-mono);
		font-size: var(--text-micro);
		letter-spacing: var(--tracking-label);
		color: var(--speed-on-ink);
		font-weight: 600;
	}

	.value {
		margin: 12px 0;
		font-family: var(--font-mono);
		font-weight: 700;
		text-align: center;
		word-break: normal;
	}

	.value.long {
		word-break: break-all;
	}

	.note {
		margin: 0 0 14px;
		font-size: 13.5px;
		line-height: 1.7;
		color: var(--on-ink-body);
	}

	.action {
		inline-size: 100%;
		background: var(--surface);
		color: var(--ink);
		border: none;
		cursor: pointer;
		font-family: var(--font-sans);
		font-size: 14.5px;
		font-weight: 600;
		min-block-size: var(--ctl-min);
		padding: 11px;
		border-radius: var(--radius-btn);
	}
</style>
